import React from 'react';
import PropTypes from 'prop-types';
import HSL from '@haptik/helpers/build/esm/hslBuilder';
import Box from 'relements/build/esm/ui/box';
import Icon from 'relements/build/esm/ui/icon';
import LanguageTab from '@src/components/LanguageTab/LanguageTab';
import { BASE_URL } from '@src/const';
import styles from './SmallTalkBotSays.scss';

function SmallTalkBotSays({
  variants,
  onChange,
  language,
  currentHybridLanguage,
  handleTabChange,
  isRephraseResponsesEnabled,
}) {
  return (
    <div className={styles.smallTalkBotSays} data-testid="smallTalk-botSays">
      <div className={styles.smallTalkBotSaysHeader}>
        <Icon src="bot-says" className={styles.smallTalkBotSaysHeaderIcon} />
        <div className={styles.smallTalkBotSaysHeaderText}>Bot Responses</div>
      </div>
      <Box
        borderColor="grey.neon"
        borderWidth={0}
        borderTopWidth={1}
        padding={0}
        mb={16}
      >
        <LanguageTab
          currentBotSaysLanguage={language}
          currentHybridLanguage={currentHybridLanguage}
          onLanguageChange={handleTabChange}
          variant="desktop"
        />
      </Box>
      <div className={styles.smallTalkBotSaysBody}>
        <HSL
          value={variants}
          onChange={onChange}
          withVariants
          withReplies
          isRephraseEnabled={isRephraseResponsesEnabled && language === 'en'}
          baseUrl={BASE_URL}
        />
      </div>
    </div>
  );
}

SmallTalkBotSays.propTypes = {
  variants: PropTypes.array,
  onChange: PropTypes.func,
  isRephraseResponsesEnabled: PropTypes.bool,
};

SmallTalkBotSays.defaultProps = {
  variants: [],
  onChange: () => {},
  isRephraseResponsesEnabled: false,
};

export default SmallTalkBotSays;
